import { CORE_UI } from '@mri-platform/shared/core-ui';
import { AvatarIconSelectorFormComponent } from './lib/components/avatar-icon-selector-form/avatar-icon-selector-form.component';
import { AvatarIconSelectorPopupComponent } from './lib/components/avatar-icon-selector-popup/avatar-icon-selector-popup.component';
import { EditableColumnSelectAllDirective } from './lib/components/editiable-column-select-all.directive';
import { KendoRequiredDirective } from './lib/components/kendo-required/kendo-required.directive';
import { FileRestrictionsMessagePipe } from './lib/pipes/file-restrictions-message.pipe';
import { ParseDatePipe } from './lib/pipes/parse-date.pipe';
import { ParseTimePipe } from './lib/pipes/parse-time.pipe';

export * from './lib/functions/can-grid-select-all';
export * from './lib/functions/forms/create-form-group-proxy';
export * from './lib/functions/forms/dropdown';
export * from './lib/functions/forms/form-model';
export * from './lib/functions/forms/form-observables';
export * from './lib/functions/forms/form-state';
export * from './lib/functions/forms/form-validation';
export * from './lib/functions/forms/validate-alphanumeric';
export * from './lib/functions/forms/validate-no-surrounding-whitespace';
export * from './lib/functions/forms/validate-no-whitespace';
export * from './lib/functions/forms/validate-url';
export * from './lib/functions/kendo-ui';
export * from './lib/functions/process-grid-data';
export * from './lib/models';
export * from './lib/pipes/parse-date.pipe';
export * from './lib/services/avatar-image-upload.service';
export * from './lib/services/confirmation-prompt.service';

/**
 * Utility array that contains all `@mri-platform/shared/common-ui` related components and directives
 */
export const COMMON_UI = [
  AvatarIconSelectorFormComponent,
  AvatarIconSelectorPopupComponent,
  ParseDatePipe,
  ParseTimePipe,
  KendoRequiredDirective,
  FileRestrictionsMessagePipe,
  EditableColumnSelectAllDirective,
  ...CORE_UI
] as const;

export {
  AvatarIconSelectorFormComponent,
  AvatarIconSelectorPopupComponent,
  CORE_UI,
  EditableColumnSelectAllDirective,
  FileRestrictionsMessagePipe,
  KendoRequiredDirective,
  ParseDatePipe,
  ParseTimePipe
};
